import { render, staticRenderFns } from "./CurrentPhotoBook.vue?vue&type=template&id=09d15f1b"
import script from "./CurrentPhotoBook.vue?vue&type=script&lang=js"
export * from "./CurrentPhotoBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports